import React, { useRef } from 'react'
import { useApi, useCircle } from '../../systems/Physics/hooks'
import useCollision from '../../hooks/useCollision'
import UfoBase from '../UfoBase'
import { useEvents } from '../../systems/World/hooks'
import { CHARACTER_EVENTS } from '../../systems/World/Events'

const Portals = ({ positionBlue = [0,0,0], positionRed = [5, 0, 5]}) => {
  const [portalBlue] = useCircle({})
  const [portalRed] = useCircle({})
  let teleporting = useRef([]).current
  const api = useApi()
  const onTeleportTrigger = useEvents(CHARACTER_EVENTS.TELEPORT)
  useCollision(collidedFixture => {
    const uuid = collidedFixture.GetBody().GetUserData().uuid
    if (!teleporting.includes(uuid)) {
      teleporting.push(uuid)
      setTimeout(() => {
        api.hyperJump(
          uuid,
          { x: positionRed[0], y: positionRed[2] }
        )
        onTeleportTrigger()
      }, 0)
    } else {
      teleporting = teleporting.filter(id => id !== uuid)
    }
  }, portalBlue.current?.uuid)
  useCollision(collidedFixture => {
    const uuid = collidedFixture.GetBody().GetUserData().uuid
    if (!teleporting.includes(uuid)) {
      teleporting.push(uuid)
      setTimeout(() => {
        api.hyperJump(
          collidedFixture.GetBody().GetUserData().uuid,
          { x: positionBlue[0], y: positionBlue[2] }
        )
        onTeleportTrigger()
      }, 0);
    } else {
      teleporting = teleporting.filter(id => id !== uuid)
    }
  }, portalRed.current?.uuid)

  return (
    <>
      <UfoBase
        ref={portalBlue}
        colorPalette={[
          '#32aaf8',
          '#ff2147',
          '#878787',
          '#e4e4ef'
        ]}
        position={positionBlue}
        userData={{ origin: positionBlue, pickable: true, radius: 0.25, rotate: false }}
      />
        
      <UfoBase
        ref={portalRed}
        colorPalette={[
          '#ff2147',
          '#32aaf8',
          '#878787',
          '#e4e4ef'
        ]}
        position={positionRed}
        userData={{ origin: positionRed, pickable: true, radius: 0.25, rotate: false }}
      />
    </>
  )
}

export default Portals